import React, { useEffect, useState } from "react";
import AddNewEntry from "./AddNewEntry";
import { getApplicationReportHeaderDetails } from "../../services/applicationReport";
import { getDistributorNames } from "../../Common/functions";

const baseTitles = [
  { title: "Lead" },
  { title: "Demo" },
  { title: "Sale" },
  { title: "No sale" },
];

const Header = ({ stats, userRole }) => {
  const [openAddNewBox, setOpenAddNewBox] = useState(false);
  const [values, setValues] = useState(["0", "0", "0", "0"]);

  const getHeadersDetails = async () => {
    try {
      const payload = {
        category: "sales tracking",
      };

      if (userRole !== "super_admin") {
        payload.distributor_name = getDistributorNames();
      }
      const response = await getApplicationReportHeaderDetails(payload);
      const totalRecords = response?.data?.entire_time_records_by_status;
      if (totalRecords) {
        setValues([
        totalRecords.Lead || 0,
        totalRecords.Demo || 0,
        totalRecords.Sale || 0,
        totalRecords.NoSale || 0,
      ]);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching header details:", error);
    }
  };

  useEffect(() => {
    getHeadersDetails();
  }, []);

  return (
    <>
      <div className="px-0 sm:px-4 space-y-6 pt-4 ">
        <div className="flex justify-between gap-2">
          <h1 className="text-2xl sm:text-3xl leading-9 font-bold text-text1">
            Application report
          </h1>
          {userRole !== "super_admin" && (
            <div>
              <button
                className="text-white text-sm bg-primary px-3 py-2 rounded-md"
                onClick={() => setOpenAddNewBox(true)}
              >
                Add New
              </button>
            </div>
          )}
        </div>
         <div
          className={`grid mb-3 ${
            userRole === "manager"
              ? "grid-cols-2 sm:grid-cols-5 gap-5"
              : "grid-cols-2 sm:grid-cols-4 gap-5"
          }`}
        >
          {baseTitles.map((item, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-3 lg:p-6 flex justify-between items-center w-full shadow-lg"
            >
              <div>
                <h2 className="text-sm lg:text-base font-medium text-text2 text-left">
                  {item.title}
                </h2>
                <p className="lg:text-3xl text-2xl font-bold text-text2 text-left">
                  {values[index]}
                </p>
              </div>
            </div>
          ))}
        </div>
        <hr />
      </div>
      {openAddNewBox && (
        <AddNewEntry
          userRole={userRole}
          closeModal={() => setOpenAddNewBox(false)}
        />
      )}
    </>
  );
};

export default Header;
